import { createAsyncThunk } from '@reduxjs/toolkit';
import payrollServiceApiInstance from '../../../../../../config/payrollApiConfig';

// Create
export const createPfPolicy = createAsyncThunk(
  'pfPolicy/create',
  async (data: any, { rejectWithValue }) => {
    try {
      const res = await payrollServiceApiInstance.post('/pf-policy', data);
      return res.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || 'Failed to create PF policy');
    }
  }
);

// Get All
export const fetchAllPfPolicies = createAsyncThunk(
  'pfPolicy/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const res = await payrollServiceApiInstance.get('/pf-policy');
      return res.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || 'Failed to fetch PF policies');
    }
  }
);

// Get By ID
export const fetchPfPolicyById = createAsyncThunk(
  'pfPolicy/fetchById',
  async (id: number, { rejectWithValue }) => {
    try {
      const res = await payrollServiceApiInstance.get(`/pf-policy/${id}`);
      return res.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || 'Failed to fetch PF policy');
    }
  }
);

// Update
export const updatePfPolicy = createAsyncThunk(
  'pfPolicy/update',
  async ({ id, data }: { id: number; data: any }, { rejectWithValue }) => {
    try {
      await payrollServiceApiInstance.put(`/pf-policy/${id}`, data);
      return { id, data };
    } catch (err: any) {
      return rejectWithValue(err.response?.data || 'Failed to update PF policy');
    }
  }
);

// Delete
export const deletePfPolicy = createAsyncThunk(
  'pfPolicy/delete',
  async (id: number, { rejectWithValue }) => {
    try {
      await payrollServiceApiInstance.delete(`/pf-policy/${id}`);
      return id;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || 'Failed to delete PF policy');
    }
  }
);
